export default "__VITE_ASSET__BL5pgCtd__"